<script>
export default {
  data() {
    return {
      types: [],
      usedTags: [],
      filters: {
        available: [
          {
            name: 'Tagi',
            query_param: 'tags',
            options: this.setUsedTagsOptions,
            multiple: true
          }
        ],
        selected: {}
      }
    }
  },
  methods: {
    setUsedTagsOptions(options) {
      this.service
        .usedTags()
        .then(response => {
          this.tags = response.data
          options.push(...response.data)
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}
</script>
